
module.directive('affnetDial', function(AffnetReports) {
    return {
        restrict: "E",
        templateUrl: 'reports/affnetDial',
        scope: {name: '@', program: '=', text: '@', year: '='},
        link: function(scope, element, attrs) {

            if (!AffnetReports[scope.name]) return;
            var reportClass = AffnetReports[scope.name].summary;
            scope.report = new reportClass(scope.program);

            scope.$on('tagRefresh', function(event, params) {
                scope.report.update(params);
            });

            scope.$emit('requestTagParams', function(params) {
                scope.report.update(params);
            });

            if (attrs.year) {
                scope.$watch('year', updateYear);
            }

            function updateYear(year) {
                if (year) {
                    scope.report.update({year: year});
                    scope.text = (year - 1) + ' - ' +  year;
                } else {
                    scope.text = null;
                }
            }

        },
    };
});


module.directive('affnetCircle', function(AffnetReports, currencyFilter) {
    return {
        restrict: 'E',
        templateUrl: 'reports/affnetCircle',
        scope: {name: '@', program: "=", text: '@', year: '='},
        link: function(scope, element, attrs) {
            if (!AffnetReports[scope.name]) return;
            var reportClass = AffnetReports[scope.name].summary;
            scope.report = new reportClass(scope.program);
            scope.$on('tagRefresh', function(event, params) {
                scope.report.update(params);
            });

            scope.getText = function() {
                if (!scope.report || !scope.report.loaded) {
                    return "";
                } else if (scope.name === 'wage' ) {
                    return currencyFilter(scope.report.data.wage)
                } else {
                    return (scope.report.getPercent() || 0).toFixed(0) + "%";
                }
            }

            scope.$emit('requestTagParams');
        },
    }
});
